/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */

import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Card,
  CardContent,
  // CardActions,
  CardHeader,
  // InputAdornment,
  // IconButton,
  // MenuItem,
  Button,
  CircularProgress,
  Grid,
  TextField
} from '@mui/material';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import SettingAction from '../../../store/actions/SettingAction';
import ContentLoader from '../../../utils/errorPages/ContentLoader';
import { ValidateVeem } from '../../../assets/validation';
import useHasPermission from '../../../utils/useHasPermission';
import { paymentSettings, index, store } from '../../../utils/constants';
import IOSSwitchStyle from '../../../components/SwitchField';

export default function PaymentVeem() {
  const [data, setData] = useState([]);
  const [modeValue, setModeValue] = useState('');

  const dispatch = useDispatch();
  const { veemData, isLoading } = useSelector((state) => state.setting); // Replace 'data' with your reducer name

  useEffect(() => {
    dispatch(SettingAction.getVeem());
  }, [dispatch]);

  useEffect(() => {
    if (veemData && veemData?.data) {
      setData(veemData.data);
      if (veemData.data?.VEEM_MODE) {
        setModeValue(veemData.data.VEEM_MODE);
      }
    }
  }, [veemData]);

  const getDirtyValues = (values, initialObject) => {
    const newdata = { ...values };
    const keyValues = Object.keys(newdata);

    const dirtyValues = keyValues.filter(
      (keyValue) => newdata[keyValue] !== initialObject[keyValue]
    );

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete newdata[key];
    });
    return newdata;
  };

  const initialValues = {
    VEEM_MODE: data?.VEEM_MODE ?? '',
    VEEM_SANDBOX_CLIENT_ID: data?.VEEM_SANDBOX_CLIENT_ID ?? '',
    VEEM_SANDBOX_CLIENT_SECRET: data?.VEEM_SANDBOX_CLIENT_SECRET ?? '',
    VEEM_LIVE_CLIENT_ID: data?.VEEM_LIVE_CLIENT_ID ?? '',
    VEEM_LIVE_CLIENT_SECRET: data?.VEEM_LIVE_CLIENT_SECRET ?? '',
    VEEM_IS_ENABLED: data?.VEEM_IS_ENABLED
  };

  const permissionAccess = !(
    useHasPermission(paymentSettings, index) && useHasPermission(paymentSettings, store)
  );

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {isLoading ? <ContentLoader /> : ''}
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={ValidateVeem}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          console.log(values, 'values');
          const updateValues = getDirtyValues(values, initialValues);
          dispatch(SettingAction.updateVeem(updateValues, setErrors, setSubmitting));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                  <Grid item lg={3} xl={2}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess}>
                        Veem Mode
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="statusId-label"
                        name="VEEM_MODE"
                        value={values.VEEM_MODE}
                        onChange={(e) => {
                          setFieldValue('VEEM_MODE', e.target.value);
                          setModeValue(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="sandbox"
                          control={<Radio />}
                          label="Sandbox"
                        />
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="live"
                          control={<Radio />}
                          label="Live"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item lg={3} xl={3}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess} sx={{ mb: 1 }}>
                        Status
                      </FormLabel>
                      <IOSSwitchStyle
                        size="small"
                        disabled={permissionAccess}
                        checked={values.VEEM_IS_ENABLED === 1}
                        value={values.VEEM_IS_ENABLED}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFieldValue('VEEM_IS_ENABLED', 1);
                          } else {
                            setFieldValue('VEEM_IS_ENABLED', 2);
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                {modeValue === 'sandbox' ? (
                  <Card sx={{ mt: 2, maxWidth: '65%' }}>
                    <CardHeader
                      sx={{ textAlign: 'left !important' }}
                      title="Sandbox Configuration"
                    />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={errors.VEEM_SANDBOX_CLIENT_ID && touched.VEEM_SANDBOX_CLIENT_ID}
                            label="Veem Sandbox Client ID"
                            className=""
                            fullWidth
                            type="text"
                            name="VEEM_SANDBOX_CLIENT_ID"
                            value={values.VEEM_SANDBOX_CLIENT_ID}
                            disabled={permissionAccess}
                            // maxRows={4}
                            placeholder="Enter Client ID"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.VEEM_SANDBOX_CLIENT_ID &&
                              touched.VEEM_SANDBOX_CLIENT_ID &&
                              errors.VEEM_SANDBOX_CLIENT_ID
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={
                              errors.VEEM_SANDBOX_CLIENT_SECRET &&
                              touched.VEEM_SANDBOX_CLIENT_SECRET
                            }
                            label="Veem Sandbox Client Secret"
                            className=""
                            fullWidth
                            type="text"
                            name="VEEM_SANDBOX_CLIENT_SECRET"
                            value={values.VEEM_SANDBOX_CLIENT_SECRET}
                            disabled={permissionAccess}
                            // maxRows={4}
                            placeholder="Enter Client Secret"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.VEEM_SANDBOX_CLIENT_SECRET &&
                              touched.VEEM_SANDBOX_CLIENT_SECRET &&
                              errors.VEEM_SANDBOX_CLIENT_SECRET
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                ) : (
                  <Card sx={{ mt: 2, maxWidth: '65%' }}>
                    <CardHeader sx={{ textAlign: 'left !important' }} title="Live Configuration" />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={6} xl={6}>
                          <TextField
                            id="VEEM_LIVE_CLIENT_ID"
                            fullWidth
                            label="Veem Live Client ID"
                            name="VEEM_LIVE_CLIENT_ID"
                            type="text"
                            margin="normal"
                            placeholder="Enter Client ID"
                            disabled={permissionAccess}
                            value={values.VEEM_LIVE_CLIENT_ID}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const val = (e.target.value || '').replace(/\s+/gi, '');
                              setFieldValue(e.target.name, val.trim());
                              handleBlur(e);
                            }}
                            error={errors.VEEM_LIVE_CLIENT_ID && touched.VEEM_LIVE_CLIENT_ID}
                            helperText={
                              errors.VEEM_LIVE_CLIENT_ID &&
                              touched.VEEM_LIVE_CLIENT_ID &&
                              errors.VEEM_LIVE_CLIENT_ID
                            }
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={
                              errors.VEEM_LIVE_CLIENT_SECRET && touched.VEEM_LIVE_CLIENT_SECRET
                            }
                            label="Veem Live Client Secret"
                            className=""
                            fullWidth
                            type="text"
                            name="VEEM_LIVE_CLIENT_SECRET"
                            value={values.VEEM_LIVE_CLIENT_SECRET}
                            disabled={permissionAccess}
                            // maxRows={4}
                            placeholder="Enter Client Secret"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.VEEM_LIVE_CLIENT_SECRET &&
                              touched.VEEM_LIVE_CLIENT_SECRET &&
                              errors.VEEM_LIVE_CLIENT_SECRET
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}
              </CardContent>
              {!permissionAccess ? (
                <CardContent
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.06)',
                    p: 2,
                    columnGap: '16px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                      setModeValue(data?.VEEM_MODE);
                    }}
                  >
                    Clear
                  </Button>
                </CardContent>
              ) : (
                ''
              )}
            </Card>
          </form>
        )}
      </Formik>
    </Box>
  );
}
